// extracted by mini-css-extract-plugin
module.exports = {"project-tech-icon":"ProjectTechIcon_project-tech-icon__3irH8"};